module.exports = __webpack_public_path__ + "media/images/icons/filled/bulb-71c8c40a3bc595d02d2859f580a90c3e.svg";